import AppRedux from './AppRedux'
import AuthRedux from './AuthRedux'
import AssetsRedux from './AssetsRedux'
import EntityClassesRedux from './EntityClassesRedux'
import EntityTypesRedux from './EntityTypesRedux'
import HallsRedux from './HallsRedux'
import SitesRedux from './SitesRedux'
import RegionsRedux from './RegionsRedux'

import CategoriesRedux from './CategoriesRedux'
import NdlDeploymentsRedux from './NdlDeploymentsRedux'
import NdlFlowRunsRedux from './NdlFlowRunsRedux'
import NdlArtifactsRedux from './NdlArtifactsRedux'

import RecordingsRedux from './RecordingsRedux'
import SmDefinitionsRedux from './SmDefinitionsRedux'
import StateDefinitionsRedux from './StateDefinitionsRedux'
import StateValuesRedux from './StateValuesRedux'
import ContextDefinitionsRedux from './ContextDefinitionsRedux'
import ContextValuesRedux from './ContextValuesRedux'

import AlertsRedux from './AlertsRedux'



export default {
    app: AppRedux,
    auth: AuthRedux,
    assets: AssetsRedux,
    entityClasses: EntityClassesRedux,
    entityTypes: EntityTypesRedux,
    halls: HallsRedux,
    sites: SitesRedux,
    regions: RegionsRedux,
    categories: CategoriesRedux,
    ndlDeployments: NdlDeploymentsRedux,
    ndlFlowRuns: NdlFlowRunsRedux,
    ndlArtifacts: NdlArtifactsRedux,
    recordings: RecordingsRedux,
    smDefinitions: SmDefinitionsRedux,
    stateDefinitions: StateDefinitionsRedux,
    stateValues: StateValuesRedux,
    contextDefinitions: ContextDefinitionsRedux,
    contextValues: ContextValuesRedux,
    alerts: AlertsRedux,
}